import Box from "@material-ui/core/Box";
import { DialogProps } from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import RequestsPagePathParams from "../../../api/models/test-request/RequestsPagePathParams";
import ProductSamplesApi from "../../../api/services/ProductSamplesApi";
import SubstrateSamplesApi from "../../../api/services/SubstrateSamplesApi";
import TestRequestApi from "../../../api/services/TestRequestApi";
import CustomButton from "../../../components/Button/CustomButton";
import CustomDialog from "../../../components/Dialog/CustomDialog";
import CustomTextField from "../../../components/Input/CustomTextField";
import ErrorSnackbarContext, { SnackbarVisibility } from "../../../contexts/ErrorSnackbarContext";
import useEnv from "../../../hooks/env";

interface ProductSampleAddExistingProductDialogProps extends DialogProps {
  onClose: () => void;
  onSelected: () => void;
  action: "USE" | "DUPLICATE";
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      marginBottom: theme.spacing(5),
      textTransform: "uppercase",
    },
  }),
);

const ProductSampleAddExistingProductDialog: React.FC<ProductSampleAddExistingProductDialogProps> = (props) => {
  const { action, open, onClose, onSelected } = props;
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState("");
  const [isError, setIsError] = useState(false);
  const { handleHttpError, showSnackbar } = useContext(ErrorSnackbarContext);
  const { testRequestId } = useParams<RequestsPagePathParams>();
  const errorMessage = "Please enter an existing Product Sample ID";
  const { api } = useEnv();
  const productSamplesApi = new ProductSamplesApi(api);

  const addProductSamples = (productSampleId: number) => {
    if (action === "USE") {
      return productSamplesApi.updateTestRequestProducts(testRequestId, [productSampleId]);
    }
    // else action === "DUPLICATE"
    return productSamplesApi.cloneThenAddProductSampleToTestRequest(testRequestId, productSampleId);
  };

  const actionAsText = action.charAt(0) + action.slice(1).toLowerCase();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const productSampleId = parseInt(searchTerm, 10);
    addProductSamples(productSampleId)
      .then(() => {
        showSnackbar(`Product sample ${actionAsText.toLowerCase()}d`, "success");
        onSelected();
      })
      .catch((error) => {
        if (error?.response?.status === 404) {
          handleHttpError(error, SnackbarVisibility.HIDDEN);
          setIsError(true);
        } else {
          handleHttpError(error);
        }
      });
  };

  useEffect(() => {
    if (!open) {
      return () => {
        setIsError(false);
        setSearchTerm("");
      };
    }
  });

  return (
    <CustomDialog fullWidth maxWidth="sm" onClose={onClose} open={open}>
      <h2 className={classes.header}>{actionAsText} EXISTING PRODUCT SAMPLE</h2>
      <form onSubmit={handleSubmit}>
        <Grid container justify="flex-start" direction="row" spacing={4}>
          <Grid item xs={12}>
            <CustomTextField
              autoFocus
              error={isError}
              fullWidth
              helperText={isError ? errorMessage : undefined}
              label="Sample ID"
              mandatory
              noSpinners
              onChange={(event): void => {
                const term = event.target.value as string;
                setSearchTerm(term);
                if (isError) {
                  setIsError(false);
                }
              }}
              type="number"
              value={searchTerm}
            />
          </Grid>
          <Grid container item xs={12} justify="flex-end">
            <Box>
              <CustomButton disabled={!searchTerm} primary text={actionAsText} type="submit" />
            </Box>
          </Grid>
        </Grid>
      </form>
    </CustomDialog>
  );
};

export default ProductSampleAddExistingProductDialog;
